const binding = { modules: {}, dataActions: {} };

    const registerActionId = (actionPath) => {
        if (binding.dataActions[actionPath] &&
            binding.dataActions[actionPath].default &&
            binding.dataActions[actionPath].default.prototype &&
            binding.dataActions[actionPath].default.prototype.id) {
            binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
        } else {
            Object.keys(binding.dataActions[actionPath] || {}).forEach(exportName => {
                if (binding.dataActions[actionPath][exportName] &&
                    binding.dataActions[actionPath][exportName].prototype &&
                    binding.dataActions[actionPath][exportName].prototype.Action) {
                    binding.dataActions[binding.dataActions[actionPath][exportName].prototype.id] = binding.dataActions[actionPath][exportName];
                }
            })
        }
    };

    const registerSanitizedActionPath = (sanitizedActionPath, dataAction) => {
        if (process.env.NODE_ENV === 'development') {
            if (!dataAction.default) {
                throw new Error('Data action path does not have a default export');
            }
            if (!(dataAction.default.prototype.id && binding.dataActions[dataAction.default.prototype.id]) || !binding.dataActions[sanitizedActionPath]) {
                binding.dataActions[sanitizedActionPath] = dataAction;
            }
        } else {
            binding.dataActions[sanitizedActionPath] = dataAction;
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
    };
    

    (binding.modules['cus-product-list'] = {
        c: () => require('partner/modules/cus-product-list/cus-product-list.tsx'),
        $type: 'contentModule',
        da: [{name:'categoryNavigation',  path:'integrations/relewise/data-actions/getProductListCategoryNavigationData', runOn: 0},{name:'categoryProducts',  path:'integrations/relewise/data-actions/getProductListCategoryData', runOn: 0},{name:'filters',  path:'integrations/relewise/data-actions/getProductListFiltersData', runOn: 0},{name:'searchProducts',  path:'integrations/relewise/data-actions/getProductListSearchData', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'cus-product-list',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/cus-product-list'
    });
        

        {
            const sanitizedActionPath = 'integrations/relewise/data-actions/getProductListCategoryData';
            let dataAction = require('partner/integrations/relewise/data-actions/getProductListCategoryData');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'integrations/relewise/data-actions/getProductListCategoryNavigationData';
            let dataAction = require('partner/integrations/relewise/data-actions/getProductListCategoryNavigationData');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'integrations/relewise/data-actions/getProductListFiltersData';
            let dataAction = require('partner/integrations/relewise/data-actions/getProductListFiltersData');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'integrations/relewise/data-actions/getProductListSearchData';
            let dataAction = require('partner/integrations/relewise/data-actions/getProductListSearchData');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };